module.exports = __webpack_public_path__ + "img/emoji-thumbsup-240x240.6a25b49b.png";